import script from "./AddNewView.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewView.vue?vue&type=script&setup=true&lang=js"

import "./AddNewView.vue?vue&type=style&index=0&id=085a806a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-085a806a"]])

export default __exports__